export { default } from './FlagGo'
